'use client';

import { useActiveBreakpoint } from '@nettbureau/vibrant-ui';
import { useEffect, useState } from 'react';

export const useBreakpoints = () => {
  const [isMobile, setIsMobile] = useState(false);
  const breakpoint = useActiveBreakpoint();

  useEffect(
    () => setIsMobile(!breakpoint || breakpoint === 'xs'),
    [breakpoint],
  );

  return { isMobile, breakpoint };
};
